function SectionRrss() {
  return (
    <div className="sectionRrss">
      <h3 className="sectionRrss__title"> my RR.SS.</h3>
      <h5 className="sectionRrss__text">
        You can find me here or write me directly on my{' '}
        <a
          href="mailto: ruadaslucia@gmail.com"
          className="sectionRrss__text--email"
        >
          {' '}
          email
        </a>
      </h5>

      <ul className="sectionRrss__list">
        <li className="sectionRrss__list--item">
          <a href="https://github.com/ruadaslucia">
            <i className="fa-brands fa-github sectionRrss__list--icon"></i>
          </a>
        </li>

        <li className="sectionRrss__list--item">
          <a href="https://www.linkedin.com/in/ruadaslucia/">
            <i className="fa-brands fa-linkedin sectionRrss__list--icon"></i>
          </a>
        </li>

        <li className="sectionRrss__list--item">
          <a href="https://twitter.com/ruadasLucia">
            <i className="fa-brands fa-twitter sectionRrss__list--icon"></i>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default SectionRrss;
